import type { ColDef } from 'ag-grid-community'
import { t } from '@sportninja/common/i18n'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import OfficialNameCell from '../components/cells/OfficialNameCell'
import type { GameRosterOfficial, RosterTypeOption } from '../types'
import { getOfficialAttendingLabel } from '../utils/getOfficialAttendingLabel'

interface Params {
  teamOfficialTypes: RosterTypeOption[]
  canViewAttendanceInfo: boolean
  isGenericGame: boolean
  isGameCompleted: boolean
}

/** Columns of the Team Officials grid: name, role, attending. */
export const useOfficialColumns = ({
  teamOfficialTypes,
  ...attendingContext
}: Params): ColDef<GameRosterOfficial>[] => {
  'use memo'

  return [
    {
      colId: 'name',
      headerName: capitalizeWords(t('common:name', {})),
      flex: 3,
      minWidth: 220,
      cellRenderer: OfficialNameCell,
    },
    {
      colId: 'team_official_type',
      headerName: capitalizeWords(t('common:role', {})),
      flex: 2,
      minWidth: 160,
      valueGetter: ({ data }) =>
        teamOfficialTypes.find(
          (type) => String(type.id) === String(data?.team_official_type)
        )?.name_full || '-',
    },
    {
      colId: 'attending',
      headerName: capitalizeWords('Attending'),
      flex: 2,
      minWidth: 160,
      valueGetter: ({ data }) =>
        getOfficialAttendingLabel(data?.is_attending, attendingContext),
    },
  ]
}
